import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Backdrop, Box, Modal } from '@mui/material'
import React from 'react'
import ReportGlobalFiltersProvider from '../../../../providers/ReportGlobalFiltersProvider'
import { reportListObject, reportModalProps } from '../../types/types'
import DownloadPage from '../DownloadPage'
import './ReportDownloadModal.css'
import DefaultHeading from '../../../../components/heading/DefaultHeading';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider'

const ReportDownloadModal = (props: reportModalProps) => {
  const { translate } = usePortalTranslation();

  return (
    <Backdrop
      open={props.showReportModal}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    // onClose={() => { props.setShowReportModal(false) }}
    // style={{ tabIndex: 1000 }}
    >
      <Box className='report-download-modal'>
        <div className='header-button'>
          <DefaultHeading heading={props.name?.endsWith(" Report")
            ? translate(TranslationEnum.reports,props.name)
            : translate(TranslationEnum.reports,`${props.name} Report`)}
            children={
              <span onClick={() => { props.setShowReportModal(false) }} className='report-download-modal-cross'><FontAwesomeIcon icon={faXmark} color="white" /> </span>
            }
          />
        </div>

        <ReportGlobalFiltersProvider>
          <div className='report-download-modal-cross-container'>
            <DownloadPage
              report={props.report}
              id={props.id}
              name={props.name}
              type={props.type}
              filter={props.filter}
              setShowReportModal={props.setShowReportModal}
              parentFilter={props.parentFilter}
              globalFilters={props.globalFilters}
              batchDownload={props.batchDownload}
            />
          </div>
        </ReportGlobalFiltersProvider>
      </Box>
    </Backdrop>
  )
}

export default ReportDownloadModal